import * as d3 from 'd3';


export function drawVictorianGrills(
  svg,
  x,
  y,
  width,
  height,
  frameWidth = 10,
  rows = 3,
  cols = 3,
  lineColor = 'white',
  borderColor = 'black',
  borderWidth = 0.2,
  grillThickness = 2
) {
  const glassX = x;
  const glassY = y;
  const glassWidth = width;
  const glassHeight = height;

  // Draw vertical lines (columns)
  for (let i = 1; i < cols; i++) {
    const gx = glassX + (glassWidth * i) / cols;
    svg.append('rect')
      .attr('x', gx - grillThickness / 2)
      .attr('y', glassY)
      .attr('width', grillThickness)
      .attr('height', glassHeight)
      .attr('fill', lineColor)
      .attr('stroke', borderColor)
      .attr('stroke-width', borderWidth);
  }

  // Draw horizontal lines (rows)
  for (let i = 1; i < rows; i++) {
    const gy = glassY + (glassHeight * i) / rows;
    svg.append('rect')
      .attr('x', glassX)
      .attr('y', gy - grillThickness / 2)
      .attr('width', glassWidth)
      .attr('height', grillThickness)
      .attr('fill', lineColor)
      .attr('stroke', borderColor)
      .attr('stroke-width', borderWidth);
  }
}

export function drawVictorianGrills1(
  svg,
  x,
  y,
  width,
  height,
  frameWidth = 10,
  rows = 3,
  cols = 3,
  lineColor = 'white',
  grillThickness = 2
) {
  const glassX = x;
  const glassY = y;
  const glassWidth = width;
  const glassHeight = height;

  // Draw vertical lines (columns)
  for (let i = 1; i < cols; i++) {
    const gx = glassX + (glassWidth * i) / cols;
    svg.append('rect')
      .attr('x', gx - grillThickness / 2)
      .attr('y', glassY)
      .attr('width', grillThickness)
      .attr('height', glassHeight)
      .attr('fill', lineColor);
  }

  // Draw horizontal lines (rows)
  for (let i = 1; i < rows; i++) {
    const gy = glassY + (glassHeight * i) / rows;
    svg.append('rect')
      .attr('x', glassX)
      .attr('y', gy - grillThickness / 2)
      .attr('width', glassWidth)
      .attr('height', grillThickness)
      .attr('fill', lineColor);
  }
}
